(function(){
'use strict';

const esc = s => (s==null?'':String(s)).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const $ = s => document.querySelector(s);
const $$ = s => Array.from(document.querySelectorAll(s));

const DAYS = ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'];
const MONTHS = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
const MONTHS_SHORT = ['jan','fév','mars','avr','mai','juin','juil','août','sept','oct','nov','déc'];  // 'juin'/'juillet' se confondent en slice(0,3)

// Genre → palette token (matches the "chaud/froid" system described in the brief)
// Accents doivent matcher scrapers/genre_mapper.py ALLOWED_GENRES
// (bug corrigé 2026-04-20 : "Pop & Variete" sans accent → filtre invisible).
const GENRE_COLOR = {
  'Pop & Variété':'#F59E32','Rock':'#E8562C','Rap & Hip-Hop':'#D4623F','RnB':'#B96F9A',
  'Électro':'#F59E32','Jazz / Soul / Funk':'#7BA9A6','Reggae & World':'#C9A44B',
  'Classique':'#5E9DB6','Métal / assimilés':'#E8562C','Folk / Indie':'#CFB065',
  'Spectacles':'#B96F9A','Humour':'#F59E32','Musique de Film':'#5E9DB6','Autre':'#9C9AA6'
};

// Priority order for genre filter pills
const GENRE_ORDER = [
  'Rock','Rap & Hip-Hop','Pop & Variété','Électro','Jazz / Soul / Funk',
  'Métal / assimilés','Folk / Indie','Reggae & World','RnB','Classique',
  'Spectacles','Humour','Musique de Film','Autre'
];

const SORTS = [
  {k:'next', label:'Prochainement'},
  {k:'dates', label:'+ de dates'},
  {k:'alpha', label:'A → Z'}
];

const STATE = {
  artists: [],          // [{slug, name, events[], genre, venues[], nextDate, color, local[]…}]
  genreFilter: 'all',
  sort: 'next',
  search: '',
  limit: 36,
  pageSize: 24
};

// ---------- ville de la page ----------
// La liste reste nationale (un artiste tourne partout), mais la ville de la
// page passe en tete : /lyon/artistes/ montre d'abord les artistes qui passent
// a Lyon, puis le reste de la France. Ville et salles : js/villes.js
// (LAgendaVilles). Sans lui (fichier absent, villes.json injoignable), la page
// reste celle de Paris : les dates du fichier Paris d'abord.
const PARIS = {slug:'paris', nom:'Paris', a_nom:'à Paris', de_nom:'de Paris'};
// villes.json pese quelques dizaines de Ko et arrive avant les dates : ce
// delai ne sert que si le fichier ne repond jamais.
const VILLE_TIMEOUT_MS = 8000;
let VILLE = PARIS;

function villesApi(){ return window.LAgendaVilles || null; }

// Ville de la page, ou null si le module des villes ne repond pas.
async function villeDeLaPage(){
  const api = villesApi();
  if (!api || !api.ready) return null;
  try {
    return await Promise.race([api.ready, new Promise(r => setTimeout(() => r(null), VILLE_TIMEOUT_MS))]);
  } catch(_){ return null; }
}

// Nom affichable d'une ville (slug → « Bordeaux »).
let VILLE_NOMS = null;
function villeNom(slug){
  if (!VILLE_NOMS){
    const api = villesApi();
    const all = api ? api.villes() : [];
    if (!all.length) return slug === 'paris' ? 'Paris' : '';
    VILLE_NOMS = Object.fromEntries(all.map(v => [v.slug, v.nom]));
  }
  return VILLE_NOMS[slug] || '';
}

// Ou se joue une date : ville de l'agenda (slug), commune, salle telle qu'on
// l'ecrit (« au Transbordeur »). Le fichier Paris ne porte que des salles de
// Paris (whitelist de export_to_json) : elles sont toutes a la ville de Paris,
// commune lue dans venues-data.js (Nanterre, Saint-Denis…). Une salle de
// province prend sa ville dans villes.json ; inconnue, elle n'est d'aucune
// ville et compte « ailleurs ».
function placeOf(e){
  if (e.source === 'paris'){
    const legacy = window.VENUES_LEGACY ? window.VENUES_LEGACY[e.venue] : null;
    const full = window.VENUE_BY_NAME ? window.VENUE_BY_NAME[e.venue] : null;
    return {
      ville: 'paris', villeNom: 'Paris', commune: (full && full.city) || 'Paris',
      prep: legacy ? legacy.prep : 'à ', nom: legacy ? legacy.display : e.venue
    };
  }
  const api = villesApi();
  const s = api ? api.salle(e.venue) : null;
  if (s){
    return {
      ville: s.ville, villeNom: villeNom(s.ville) || s.commune || '', commune: s.commune || '',
      prep: s.prep || 'à ', nom: s.nom || e.venue
    };
  }
  return {ville: null, villeNom: '', commune: '', prep: 'à ', nom: e.venue};
}

// Range chaque date par ville (a refaire si villes.json arrive en retard),
// puis, pour la ville de la page, les dates de chaque artiste qui s'y jouent.
function placeEvents(){
  for (const a of STATE.artists){
    for (const e of a.events) e.place = placeOf(e);
    a.villesCount = new Set(a.events.map(e => e.place.ville || `?${e.venue}`)).size;
  }
}
function applyVille(){
  for (const a of STATE.artists){
    a.local = a.events.filter(e => e.place.ville === VILLE.slug);
    a.nextLocal = a.local[0] || null;
  }
}

function renderIntro(){
  const sub = $('.salles-intro .sub');
  if (sub) sub.textContent = `Ceux qui passent ${VILLE.a_nom} d'abord, puis leurs dates partout en France. Triés par date de prochain concert.`;
}

// ---------- slug helpers (ported from generate_seo_pages.py) ----------
function stripAccents(s){ return s.normalize('NFD').replace(/[\u0300-\u036f]/g,''); }
function cleanArtistName(name){
  if (!name) return '';
  let s = name.replace(/\s*\([^)]*(?:live|dj\s*set|concert|acoustic|solo|trio|quartet|quintet|set|tour|session)[^)]*\)/ig,'');
  s = s.replace(/\s+feat\..*$/i,'');
  s = s.replace(/\s*[-–]\s*(?:live|concert|tour|dj\s*set)\b.*$/i,'');
  return s.trim();
}
function slugify(text){
  if (!text) return '';
  let s = stripAccents(String(text).toLowerCase());
  s = s.replace(/[^\x00-\x7f]/g,'');
  s = s.replace(/[\s\u2013-]+(?:infernal )?tour.*$/,'');
  s = s.replace(/[\s\u2013-]+in concert.*$/,'');
  s = s.replace(/[\s\u2013-]+live.*$/,'');
  s = s.replace(/[\s\u2013-]+concert.*$/,'');
  s = s.replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
  return s;
}
function makeArtistSlug(name){ return slugify(cleanArtistName(name||'')); }
function titleCase(name){
  // Normalize display casing: "disiz" → "Disiz", "FLORENT PAGNY" → "Florent Pagny"
  // Keep names that already mix cases (e.g. "Fontaines D.C.", "Orelsan").
  if (!name) return name;
  if (/[a-z]/.test(name) && /[A-Z]/.test(name)) return name;
  return name.toLowerCase().replace(/\b([a-zà-ÿ])/g, m => m.toUpperCase());
}

// ---------- aggregation ----------
async function loadArtists(){
  const [parisRaw, provRaw] = await Promise.all([
    fetch('/data/events_upcoming.json').then(r => r.ok?r.json():[]).catch(() => []),
    fetch('/data/province/events_upcoming.json').then(r => r.ok?r.json():[]).catch(() => [])
  ]);

  const now = new Date(); now.setHours(0,0,0,0);
  const bySlug = new Map();

  function ingest(raw, source){
    for (const e of raw){
      if (!e.date || !e.event_name) continue;
      if (e.category!=null && e.category!=='concert') continue;
      const d = new Date(e.date + 'T00:00:00');
      if (d < now) continue;
      // L'artiste, pas le titre (« Florent Pagny - la Suite du Retour ») :
      // js/event-fields.js, charge avant ce script.
      const cleaned = cleanArtistName(window.LAgendaFields.artistName(e));
      const slug = makeArtistSlug(cleaned);
      if (!slug) continue;
      let a = bySlug.get(slug);
      if (!a){
        a = {
          slug,
          rawNames: new Map(),  // cleaned → count
          events: [],
          genres: new Map(),
          venues: new Map(),
          image: null,
          nextDate: d,
          sources: new Set()
        };
        bySlug.set(slug, a);
      }
      a.rawNames.set(cleaned, (a.rawNames.get(cleaned)||0)+1);
      a.events.push({...e, dateObj:d, source});
      const g = (e.genre||'').trim();
      if (g && g !== 'Autre') a.genres.set(g, (a.genres.get(g)||0)+1);
      a.venues.set(e.venue, (a.venues.get(e.venue)||0)+1);
      if (!a.image && e.image_url) a.image = e.image_url;
      if (d < a.nextDate) a.nextDate = d;
      a.sources.add(source);
    }
  }
  ingest(parisRaw, 'paris');
  ingest(provRaw, 'province');

  STATE.artists = Array.from(bySlug.values()).map(a => {
    // Pick canonical display name = most frequent variant, with title-case fallback
    let name = null, nMax = 0;
    for (const [n,c] of a.rawNames){ if (c > nMax){ name = n; nMax = c; } }
    name = titleCase(name || a.slug);
    // Primary genre
    let genre = null, gMax = 0;
    for (const [g,c] of a.genres){ if (c > gMax){ genre = g; gMax = c; } }
    genre = genre || 'Autre';
    // Primary venue
    let topVenue = null, vMax = 0;
    for (const [v,c] of a.venues){ if (c > vMax){ topVenue = v; vMax = c; } }
    // Sort events by date
    a.events.sort((x,y) => x.dateObj - y.dateObj);
    const next = a.events[0];
    return {
      slug: a.slug,
      name,
      genre,
      color: GENRE_COLOR[genre] || '#9C9AA6',
      image: a.image,
      events: a.events,
      // Dates dans la ville de la page et nombre de villes : placeEvents() et
      // applyVille(), une fois la ville connue.
      local: [],
      nextLocal: null,
      villesCount: 0,
      venueCount: a.venues.size,
      topVenue,
      nextEvent: next,
      nextDate: a.nextDate,
      nameSlug: slugify(name),
      searchable: stripAccents(name.toLowerCase())
    };
  });
}

// ---------- filters + sort + search ----------
// Deux groupes d'une meme liste : les artistes qui passent dans la ville de la
// page, puis les autres. Filtres, recherche et tri s'appliquent dans chacun ;
// dans le premier, « Prochainement » et « + de dates » portent sur les dates
// de la ville.
function filtered(){
  let list = STATE.artists.slice();
  if (STATE.genreFilter !== 'all') list = list.filter(a => a.genre === STATE.genreFilter);
  const q = STATE.search.trim().toLowerCase();
  if (q){
    const qn = stripAccents(q);
    list = list.filter(a => a.searchable.includes(qn));
  }
  const local = list.filter(a => a.local.length);
  const rest = list.filter(a => !a.local.length);
  if (STATE.sort === 'next'){
    local.sort((a,b) => a.nextLocal.dateObj - b.nextLocal.dateObj);
    rest.sort((a,b) => a.nextDate - b.nextDate);
  } else if (STATE.sort === 'dates'){
    local.sort((a,b) => b.local.length - a.local.length || b.events.length - a.events.length || a.nextLocal.dateObj - b.nextLocal.dateObj);
    rest.sort((a,b) => b.events.length - a.events.length || a.nextDate - b.nextDate);
  } else if (STATE.sort === 'alpha'){
    const byName = (a,b) => a.name.localeCompare(b.name,'fr');
    local.sort(byName);
    rest.sort(byName);
  }
  return {local, rest};
}

function renderFilters(){
  const counts = new Map();
  for (const a of STATE.artists) counts.set(a.genre, (counts.get(a.genre)||0)+1);
  const ordered = GENRE_ORDER.filter(g => counts.has(g));
  const pills = [`<button class="pill ${STATE.genreFilter==='all'?'active':''}" data-g="all">Tous<span class="n">${STATE.artists.length}</span></button>`]
    .concat(ordered.map(g => `<button class="pill ${STATE.genreFilter===g?'active':''}" data-g="${esc(g)}">${esc(g)}<span class="n">${counts.get(g)}</span></button>`));
  $('#artistes-filters').innerHTML = pills.join('');
  $$('#artistes-filters .pill').forEach(b => b.addEventListener('click', () => {
    STATE.genreFilter = b.dataset.g;
    STATE.limit = STATE.pageSize + 12;
    renderFilters(); renderGrid();
  }));
}

function renderSort(){
  const pills = SORTS.map(s => `<button class="pill ${STATE.sort===s.k?'active':''}" data-s="${esc(s.k)}">${esc(s.label)}</button>`);
  $('#artistes-sort').innerHTML = `<span class="sort-label">Trier ·</span>` + pills.join('');
  $$('#artistes-sort .pill').forEach(b => b.addEventListener('click', () => {
    STATE.sort = b.dataset.s; renderSort(); renderGrid();
  }));
}

function renderGrid(){
  const {local, rest} = filtered();
  const total = local.length + rest.length;
  if (!total){
    $('#artistes-grid').innerHTML = '';
    $('#artistes-empty').style.display = 'block';
    $('#artistes-more').style.display = 'none';
    return;
  }
  $('#artistes-empty').style.display = 'none';
  // Une seule grille : les artistes de la ville, puis les autres, chaque
  // groupe ouvert par un intertitre qui occupe toute la largeur.
  const visLocal = local.slice(0, STATE.limit);
  const visRest = rest.slice(0, Math.max(0, STATE.limit - visLocal.length));
  const html = [];
  if (local.length){
    html.push(groupHeadHtml(`En concert <em>${esc(VILLE.a_nom)}</em>`, local.length));
    html.push(visLocal.map(a => cardHtml(a, true)).join(''));
  }
  if (visRest.length){
    const filtering = STATE.genreFilter !== 'all' || STATE.search.trim();
    const title = local.length
      ? 'Ailleurs <em>en France</em>'
      : `Aucun artiste ${esc(VILLE.a_nom)}${filtering ? ' pour cette recherche' : ' pour l’instant'} · <em>ailleurs en France</em>`;
    html.push(groupHeadHtml(title, rest.length));
    html.push(visRest.map(a => cardHtml(a, false)).join(''));
  }
  $('#artistes-grid').innerHTML = html.join('');
  const shown = visLocal.length + visRest.length;
  const more = $('#artistes-more');
  if (shown < total){
    more.style.display = 'flex';
    $('#artistes-load-more').textContent = `Voir ${Math.min(STATE.pageSize, total-shown)} de plus →`;
  } else {
    more.style.display = 'none';
  }
  $('#foot-stats').textContent = `${STATE.artists.length} artistes · ${shown} affichés`;
}

// Intertitre de groupe dans la grille. `title` est deja echappe.
function groupHeadHtml(title, n){
  return `<div class="artistes-group" role="heading" aria-level="2"><span class="t">${title}</span><span class="n">${n.toLocaleString('fr-FR')} artiste${n>1?'s':''}</span></div>`;
}

// `local` : la carte est dans le groupe de la ville de la page — prochaine
// date et compteur portent sur cette ville ; sinon, sur toute la France.
function cardHtml(a, local){
  const n = local ? a.nextLocal : a.nextEvent;
  const p = n.place || placeOf(n);
  const d = n.dateObj;
  const dateStr = `${DAYS[d.getDay()]} ${d.getDate()} ${MONTHS_SHORT[d.getMonth()]}`;
  const others = (local ? a.local.length : a.events.length) - 1;
  const multi = others > 0 ? ` +${others}` : '';
  // Dans la ville de la page, la commune suffit (Villeurbanne, Nanterre) ;
  // ailleurs, la ville de l'agenda dit ou c'est (Bordeaux plutot que Floirac).
  const where = local ? p.commune : (p.villeNom || p.commune);
  const away = a.events.length - a.local.length;
  const cap = local
    ? `${a.local.length} ${VILLE.a_nom}${away ? ` · ${a.events.length} en France` : ''}`
    : `${a.events.length} en France`;
  // « En tournée » : les dates hors de la ville de la page.
  const tourBadge = local
    ? (away > 0 ? `<span class="tour-badge">${away} en tournée</span>` : '')
    : (a.villesCount > 1 ? `<span class="tour-badge">En tournée · ${a.villesCount} villes</span>` : '');
  return `
  <a class="vcard artist-card" href="/artiste/${esc(a.nameSlug||a.slug)}/" style="--_vc:${a.color}">
    <div class="vcard-top">
      <span class="type">${esc(a.genre)}</span>
      <span class="cap">${esc(cap)}</span>
    </div>
    <h2>${esc(a.name)}</h2>
    <p class="tagline">Prochainement ${esc(p.prep)}${esc(p.nom)}${where ? ` · ${esc(where)}` : ''} · ${esc(dateStr)}${multi}</p>
    ${tourBadge}
    <div class="vcard-foot">
      <span class="next"><span class="n">${a.events.length}</span> date${a.events.length>1?'s':''}</span>
      <span class="arrow">Fiche artiste →</span>
    </div>
  </a>`;
}

function attachSearch(){
  const input = $('#a-search-input');
  if (!input) return;
  input.addEventListener('input', e => {
    STATE.search = e.target.value;
    STATE.limit = STATE.pageSize + 12;
    renderGrid();
  });
}

async function boot(){
  STATE.limit = STATE.pageSize + 12;
  const [, ville] = await Promise.all([loadArtists(), villeDeLaPage()]);
  VILLE = ville || PARIS;
  placeEvents();
  applyVille();
  renderIntro();
  renderFilters();
  renderSort();
  renderGrid();
  attachSearch();
  $('#artistes-load-more').onclick = () => { STATE.limit += STATE.pageSize; renderGrid(); };
  // villes.json arrive apres le delai : la page rendue sur Paris se recale.
  const api = villesApi();
  if (!ville && api && api.ready){
    api.ready.then(v => {
      if (!v) return;
      VILLE = v;
      VILLE_NOMS = null;
      placeEvents();
      applyVille();
      renderIntro();
      renderGrid();
    }).catch(() => {});
  }
}

document.addEventListener('DOMContentLoaded', boot);
})();
